export default __webpack_public_path__ + "static/media/2503-00.3e25bf30.jpg";